import React from 'react'
import MaterialSymbol from '../material-symbol'

const AutoAwesome = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="auto_awesome" {...props} />
))

AutoAwesome.displayName = 'AutoAwesome'

export default AutoAwesome
